import { render, staticRenderFns } from "./OverlayRouterDialog.vue?vue&type=template&id=16eaaf9d&scoped=true&"
import script from "./OverlayRouterDialog.vue?vue&type=script&lang=js&"
export * from "./OverlayRouterDialog.vue?vue&type=script&lang=js&"
import style0 from "./OverlayRouterDialog.vue?vue&type=style&index=0&id=16eaaf9d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16eaaf9d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VDialog})
